import React, {useEffect, useRef, useState} from 'react';
import {useFormik} from 'formik';
import * as yup from 'yup';
import micro_reporter_api from '../../apis/micro-reporter-api';
import {Form, Col, Button, Alert} from 'react-bootstrap';
import "../../styles/css/ConnectionForm.css";
import 'react-toastify/dist/ReactToastify.css';
import $ from "jquery";
import Utils from "../../libraries/utils";
import {Toast} from "primereact/toast";
import { useKeycloak } from '@react-keycloak/web';

const ConnectionForm = (props) => {

  const { keycloak } = useKeycloak();

  const [showConnectionNameErrorMessage, setShowConnectionNameErrorMessage] = useState(false);
    const [showParameterErrorMessage, setShowParameterErrorMessage] = useState(false);
    const [showConnectionAlreadyCreatedMessage, setShowConnectionAlreadyCreatedMessage] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    let connectionNameErrorMessage = "This connection name is already in use!"
    let parameterErrorMessage = "Cannot connect to database. Please check parameters";
    let connectionAlreadyCreatedMessage = "This connection is already created.";
    let errorMessage = "An unexpected error was encountered!";
    let connMessage = "Connection available";
    let connNotMessage = "Connection failed";

    const toast = useRef(null);

    const [databaseProviders, setDatabaseProviders] = useState([]);
    const [initValues, setInitValues] = useState({});
    const [projectList,setProjectList] = useState([]);

    const [selectedDB, setSelectedDB] = useState("");

    $( document ).ready(function() {
        if (databaseProviders.length>0){
            let a = databaseProviders.find(x => x.id === Number(document.getElementById('database-provider-box').value));
            setSelectedDB(a.providerName);
        }
    });

    let initialValues = { connName: "", host: "", port: "", database:"", databaseName: "", username: "", password: "",project:"" };
    const setInitialValuesForMssql = (data) => {
			
        let urlParts = data.jdbcUrl.split("/").join("").split(":");
        let parts = [];
        parts.push(urlParts[2]);
        urlParts = urlParts[3].split(";");
        parts.push(urlParts[0]);
        urlParts = urlParts[1].split("database=")
        parts.push(urlParts[1]);
        initialValues['connName'] = data.databaseConnectionName;
        initialValues['host'] = parts[0];
        initialValues['port'] = parts[1];
        initialValues['databaseName'] = parts[2];
        initialValues['database'] = data.databaseProvider.id;
        initialValues['username'] = data.username;
        initialValues['project'] = data.project.id;
        setInitValues(initialValues);
        return initialValues;
    };

    const setInitialValuesForPostgresql = (data) => {
        let urlParts = data.jdbcUrl.split("/");
        let parts = [];
        parts.push(urlParts[2].split(":")[0]);
        parts.push(urlParts[2].split(":")[1]);
        parts.push(urlParts[3]);
        initialValues['connName'] = data.databaseConnectionName;
        initialValues['host'] = parts[0];
        initialValues['port'] = parts[1];
        initialValues['databaseName'] = parts[2];
        initialValues['database'] = data.databaseProvider.id;
        initialValues['username'] = data.username;
        initialValues['project'] = data.project.id;
        setInitValues(initialValues);
        return initialValues;
    };

    const setInitialValuesForMysql = (data) => {
        let urlParts = data.jdbcUrl.split("/");
        let parts = [];
        parts.push(urlParts[2].split(":")[0]);
        parts.push(urlParts[2].split(":")[1]);
        parts.push(urlParts[3].split("?")[0]);
        initialValues['connName'] = data.databaseConnectionName;
        initialValues['host'] = parts[0];
        initialValues['port'] = parts[1];
        initialValues['databaseName'] = parts[2];
        initialValues['database'] = data.databaseProvider.id;
        initialValues['username'] = data.username;
        initialValues['project'] = data.project.id;
        setInitValues(initialValues);
        return initialValues;
    };

    const setInitialValuesForOracle = (data) => {
        let urlParts = data.jdbcUrl.split("@");
        let parts = [];
        parts.push(urlParts[1].split(":")[0]);
        parts.push(urlParts[1].split(":")[1]);
        parts.push(urlParts[1].split(":")[2]);
        initialValues['connName'] = data.databaseConnectionName;
        initialValues['host'] = parts[0];
        initialValues['port'] = parts[1];
        initialValues['databaseName'] = parts[2];
        initialValues['database'] = data.databaseProvider.id;
        initialValues['username'] = data.username;
        initialValues['project'] = data.project.id;
        setInitValues(initialValues);
        return initialValues;
    }

    const setInitialValuesByProviderName = (data, providerName) => {
        switch (providerName.toLowerCase()) {
            case "mssql":
                setInitialValuesForMssql(data);
                break;
            case "mysql":
                setInitialValuesForMysql(data);
                break;
            case "postgresql":
                setInitialValuesForPostgresql(data);
                break;
            case "oracle":
                setInitialValuesForOracle(data);
                break;
        }
    }

    useEffect(() => {
        let id = props.id;
        getDatabaseValues(id);
        getDatabaseProviders();
				getProjectList();
    }, [props.id]);

    const getDatabaseValues = (id) => {
        if (id !== null){
            try{
                Utils.loadingScreen("show");
                (async () => {
                    await micro_reporter_api.get(`/micro-reporter/database/find-by-id?id=${id}`).then(
                        (response) => {
                            setInitialValuesByProviderName(response.data, response.data.databaseProvider.providerName);
                            setSelectedDB(response.data.databaseProvider.id);
                            Utils.loadingScreen("hide");
                        }
                    )
                })();
            }catch(e){
                Utils.loadingScreen("hide");
            }
        }
    }

    const getDatabaseProviders = () => {
        try{
            Utils.loadingScreen("show");
            (async () => {
                const response = await micro_reporter_api.get(`/micro-reporter/database-provider/all`);
                setDatabaseProviders(response.data);
                Utils.loadingScreen("hide");
            })();
        }catch(e){
            Utils.loadingScreen("hide");
        }
    };

		const getProjectList = () => {
			try{
				Utils.loadingScreen("show");
				(async () => {
						const response = await micro_reporter_api.get(`/micro-reporter/project/all`);
						setProjectList(response.data);
						Utils.loadingScreen("hide");
				})();
			}catch(e){
				Utils.loadingScreen("hide");
			}
	};

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: yup.object({
            connName: yup.string().required('Connection Name can not be blank.'),
            host: yup.string().required('Host can not be blank.'),
            port: yup.string().required('Port can not be blank.'),
            databaseName: yup.string().required('Database Name can not be blank.'),
            username: yup.string().required('Username can not be blank.'),
            password: yup.string().required('Password can not be blank.'),
        }),
        onSubmit: values => {
            values["database"] = {id: Number(document.getElementById("database-provider-box").value)}
            values["project"] = {id: Number(document.getElementById("project-box").value)}
            values["status"] = true;
            if(props.id !== null){
                values["id"] = props.id;
                updateConnection(values);
            }else{
                saveConnection(values);
            }
        }
    });

    const trimValues = (values) => {
        let temp = values;
        for (const [key, value] of Object.entries(temp)) {
            try{
                temp[key] = value.trim();
            }catch (e) {
                temp[key] = value
            }
        }
        return temp;
    };

    const testConnection = () =>{
        let values = formik.values;
        values["database"] = {id: Number(document.getElementById("database-provider-box").value)}
        values["project"] = {id: Number(document.getElementById("project-box").value)}
        values["status"] = true;
        values = trimValues(values);
        const databaseProvider = getDatabaseProviderById(values.database.id);
        const jdbcURL = getJdbcUrl(values.host, values.port, values.databaseName, databaseProvider.providerName);
        const value = {"databaseConnectionName": values.connName, "jdbcUrl": jdbcURL, "databaseProvider": databaseProvider, "username": values.username, "password": values.password, "status": values.status, "project":values.project};
        (async () => {
            try{
                Utils.loadingScreen("show");
                let user = JSON.parse(localStorage.getItem("user"));
                let headers = {"userId": user.id, "username":user.username, "relatedName": encodeURIComponent(values.connName)};
                const config = {headers};
                await micro_reporter_api.post('/micro-reporter/database/test-connection', value, config).then(
                    () => {
                        renderTestConnectionMessage();
                        Utils.loadingScreen("hide");
                    }
                );
            }catch (err){
                renderTestNotConnectionMessage();
                Utils.loadingScreen("hide");

            }
        })();
    }

    const saveConnection = (values) =>{
        values = trimValues(values);
        const databaseProvider = getDatabaseProviderById(values.database.id);
        const jdbcURL = getJdbcUrl(values.host, values.port, values.databaseName, databaseProvider.providerName);
        const value = {"databaseConnectionName": values.connName, "jdbcUrl": jdbcURL, "databaseProvider": databaseProvider, "username": values.username, "password": values.password, "status": values.status, "project":values.project};
        (async () => {
            try{
                Utils.loadingScreen("show");
                let user = JSON.parse(localStorage.getItem("user"));
                let headers = {"userId": user.id, "username":user.username, "relatedName": encodeURIComponent(values.connName)};
                const config = {headers};
                await micro_reporter_api.post('/micro-reporter/database/connect', value, config).then(
                    () => {
                        window.location.href = createWindowLocationHref();
												Utils.loadingScreen("hide");
                    }
                );
            }catch (err){
                Utils.loadingScreen("hide");
                try{
                    showFailMessages(err.response);
                } catch (err){
                    showError();
                }
            }
        })();
    };

    const updateConnection = (values) =>{
        values = trimValues(values);
        const databaseProvider = getDatabaseProviderById(values.database.id);
        const jdbcURL = getJdbcUrl(values.host, values.port, values.databaseName, databaseProvider.providerName);
        const value = {"databaseConnectionName": values.connName, "jdbcUrl": jdbcURL, "databaseProvider": databaseProvider, "username": values.username, "password": values.password, "id":values.id, "status": values.status,"project":values.project};
        (async () => {
            try{
				Utils.loadingScreen("show");
                let user = JSON.parse(localStorage.getItem("user"));
                let headers = {"userId": user.id, "username":user.username, "relatedName": encodeURIComponent(initValues.connName), "relatedId": values.id};
                const config = {headers};
                await micro_reporter_api.post('/micro-reporter/database/update', value, config).then(
                    () => {
                        window.location.href = createWindowLocationHref();
												Utils.loadingScreen("hide");
                    }
                );
            }catch (err){
								Utils.loadingScreen("hide");
                try{
                    showFailMessages(err.response);
                } catch (err){
                    showError();
                }
            }
        })();
    };

    const createWindowLocationHref = () => {
        let pid = document.getElementById('project-box').value;
        let projectId = new URLSearchParams(window.location.search).get("projectId");

        let query = "/connections";
        if (projectId){
            query += "?projectId="+pid
        }
        return query;
    }

    const getDatabaseProviderById = (id) => {
        const dbProvider = databaseProviders.find(databaseProvider => databaseProvider.id === id);
        return dbProvider;
    }

    const getJdbcUrl = (host, port, database, dbProviderName) => {
        let jdbcURL = "";
        switch (dbProviderName) {
            case 'MsSQL':
                jdbcURL = "jdbc:sqlserver://"+host+":"+port+";database="+database+";authenticationScheme=NTLM;";
                break;
            case 'MySQL':
                jdbcURL = "jdbc:mysql://"+host+":"+port+"/"+database+"?useUnicode=yes&characterEncoding=UTF-8&useLegacyDatetimeCode=false&serverTimezone=Turkey&useSSL=false";
                break;
            case 'PostgreSQL':
                jdbcURL = "jdbc:postgresql://"+host+":"+port+"/"+database;
                break;
            case 'Oracle':
                jdbcURL = "jdbc:oracle:thin:@"+host+":"+port+":"+database;
                break;
        }
        return jdbcURL;
    }

    const renderDatabaseProviderBoxOptions = () => {
        return databaseProviders.map(databaseProvider => {
            return(
                <option selected={Number(databaseProvider.id) === initValues.database ? "selected":""} key={databaseProvider.providerName + "-cihanca-" + databaseProvider.id} value={databaseProvider.id}>{databaseProvider.providerName}</option>
            );
        });
    }

    const renderDatabaseProviderBox = () => {
        return(
            <Form.Control as="select" onChange={(event) => setSelectedDB(event.target.value)} id="database-provider-box">
                {renderDatabaseProviderBoxOptions()}
            </Form.Control>
        );
    };

    const renderProjectBoxOptions = () => {
        return projectList.map(item => {
            return(
                <option selected= {isSelected(Number(item.project.id))} key={'project-' + item.project.id} value={item.project.id}>{item.project.name}</option>
            );
        });
    }

    const isSelected = (pid) => {
        let projectId = new URLSearchParams(window.location.search).get("projectId");
        if (projectId){
            return pid === Number(projectId) ? "selected":"";
        }else if (initValues.project === pid){
            return "selected";
        }else return "";
    }

    const renderProjectBox = () => {
            return(
                    <Form.Control as="select" id="project-box">
                            {renderProjectBoxOptions()}
                    </Form.Control>
            );
    };

    const showFailMessages = (response) => {
        switch(response.status) {
            case 400:
                showParameterError();
                break;
            case 406:
                showConnectionNameError();
                break;
            case 409:
                showConnectionAlreadyCreatedError();
                break;
            default:
                showError();
        }
    };

    const showConnectionNameError = () => {
        setShowConnectionNameErrorMessage(true);
        setShowParameterErrorMessage(false);
        setShowConnectionAlreadyCreatedMessage(false);
        setShowErrorMessage(false);
    }

    const showParameterError = () => {
        setShowParameterErrorMessage(true);
        setShowConnectionNameErrorMessage(false);
        setShowConnectionAlreadyCreatedMessage(false);
        setShowErrorMessage(false);
    }

    const showConnectionAlreadyCreatedError = () => {
        setShowConnectionAlreadyCreatedMessage(true);
        setShowParameterErrorMessage(false);
        setShowConnectionNameErrorMessage(false);
        setShowErrorMessage(false);
    }

    const showError = () => {
        setShowErrorMessage(true);
        setShowConnectionNameErrorMessage(false);
        setShowConnectionAlreadyCreatedMessage(false);
        setShowParameterErrorMessage(false);
    }

    const renderDBNameText = () => {
        if (selectedDB == "Oracle"){
            return "SID";
        }else {
            return "Database Name";
        }
    };

    const renderTestConnectionMessage = () => {
              return toast.current.show({
                  severity: 'success',
                  summary: connMessage
              })
    };

    const renderTestNotConnectionMessage = () => {
            return toast.current.show({
                    severity: 'error',
                    summary: connNotMessage
            })
    };

    return(
        <div id="connection-form-panel" style={{paddingBottom: "30px"}}>
            <div>
                <div>
                    <h5 className="page-title" style={{marginBottom: "40px"}}>Database Connection</h5>
                    <Toast ref={toast}/>
                </div>
                <div>
                    {showParameterErrorMessage ?
                        (
                            <Alert variant="danger">
                                {parameterErrorMessage}
                            </Alert>
                        ) : null
                    }
                    {showConnectionAlreadyCreatedMessage ?
                        (
                            <Alert variant="danger">
                                {connectionAlreadyCreatedMessage}
                            </Alert>
                        ) : null
                    }
                    {showErrorMessage ?
                        (
                            <Alert variant="danger">
                                {errorMessage}
                            </Alert>
                        ) : null
                    }
                    <Form noValidate onSubmit={formik.handleSubmit} id="connection-form">
												<Form.Row>
                            <Form.Group as={Col} md="6">
                                <Form.Label>Project</Form.Label>
                                {renderProjectBox()}
                                {formik.touched.project && formik.errors.project ? (
                                    <div style={{fontFamily:"Lexend Deca", fontSize:"12px", color: "#ff0000"}}>{formik.errors.project}</div>
                                ) : null}
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col} md="6" controlId="validationFormik01">
                                <Form.Label>Connection Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="connName"
                                    placeholder=""
                                    onChange={formik.handleChange}
                                    value={formik.values.connName}
                                    onBlur={formik.handleBlur}
                                />
                                {formik.touched.connName && formik.errors.connName ? (
                                    <div style={{fontFamily:"Lexend Deca", fontSize:"12px", color: "#ff0000"}}>{formik.errors.connName}</div>
                                ) : null}
                                {showConnectionNameErrorMessage ?
                                    (
                                        <div style={{fontFamily:"Lexend Deca", fontSize:"12px", color: "#ff0000"}}>{connectionNameErrorMessage}</div>
                                    ) : null
                                }
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col} md="3" controlId="validationFormik02">
                                <Form.Label>Host</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="host"
                                    onChange={formik.handleChange}
                                    value={formik.values.host}
                                    onBlur={formik.handleBlur}
                                />
                                {formik.touched.host && formik.errors.host ? (
                                    <div style={{fontFamily:"Lexend Deca", fontSize:"12px", color: "#ff0000"}}>{formik.errors.host}</div>
                                ) : null}
                            </Form.Group>
                            <Form.Group as={Col} md="3" controlId="validationFormik03">
                                <Form.Label>Port</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="port"
                                    onChange={formik.handleChange}
                                    value={formik.values.port}
                                    onBlur={formik.handleBlur}
                                />
                                {formik.touched.port && formik.errors.port ? (
                                    <div style={{fontFamily:"Lexend Deca", fontSize:"12px", color: "#ff0000"}}>{formik.errors.port}</div>
                                ) : null}
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col} md="3">
                                <Form.Label>Database</Form.Label>
                                {renderDatabaseProviderBox()}
                                {formik.touched.database && formik.errors.database ? (
                                    <div style={{fontFamily:"Lexend Deca", fontSize:"12px", color: "#ff0000"}}>{formik.errors.database}</div>
                                ) : null}
                            </Form.Group>
                            <Form.Group as={Col} md="3" controlId="validationFormik05">
                                <Form.Label>
                                    {renderDBNameText()}
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    name="databaseName"
                                    onChange={formik.handleChange}
                                    value={formik.values.databaseName}
                                    onBlur={formik.handleBlur}
                                />
                                {formik.touched.databaseName && formik.errors.databaseName ? (
                                    <div style={{fontFamily:"Lexend Deca", fontSize:"12px", color: "#ff0000"}}>{formik.errors.databaseName}</div>
                                ) : null}
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col} md="3" controlId="validationFormik06">
                                <Form.Label>Username</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="username"
                                    onChange={formik.handleChange}
                                    value={formik.values.username}
                                    onBlur={formik.handleBlur}
                                />
                                {formik.touched.username && formik.errors.username ? (
                                    <div style={{fontFamily:"Lexend Deca", fontSize:"12px", color: "#ff0000"}}>{formik.errors.username}</div>
                                ) : null}
                            </Form.Group>
                            <Form.Group as={Col} md="3" controlId="validationFormik07">
                                <Form.Label>Password</Form.Label>
                                <Form.Control
                                    type="password"
                                    name="password"
                                    onChange={formik.handleChange}
                                    value={formik.values.password}
                                    onBlur={formik.handleBlur}
                                />
                                {formik.touched.password && formik.errors.password ? (
                                    <div style={{fontFamily:"Lexend Deca", fontSize:"11px", color: "#ff0000"}}>{formik.errors.password}</div>
                                ) : null}
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col} md="6">
                                <Button type="submit" style={{width:"170px", float:"right"}} >
                                    Save
                                </Button>
                                <Button variant="outline-secondary" style={{width:"170px", marginRight:"10px"}} onClick={testConnection} >
                                    Test Connection
                                </Button>
                            </Form.Group>
                        </Form.Row>
                    </Form>
                </div>
            </div>
        </div>
    );
};

export default ConnectionForm;
